import { useState } from "react";
import { useForm } from 'react-hook-form';
import ShapesDropping from '../animations/ShapesDropping';
import NitroButton from '../parts/NitroButton';

const MultiRadioRow = ({ register, answers, rowName, sides, setShapeProps}) => {
  let multiRadios = answers.map((answer, index) =>
    <div className="flex flex-col md:items-center md:mr-2 justify-end nitro-radio md:w-1/6" key={index}>
      <input
        type="radio"
        {...register(rowName, {
          required: true,
          onChange: (e) => {
            setShapeProps([
              e.target.getAttribute("data-sides"),
              e.target.getAttribute("data-color")
            ])
          }
        })}
        data-sides={sides}
        data-color={index}
        id={rowName + "-" + answer.value}
        value={answer.value}
        className="opacity-0 absolute"
      />
      <label className="radio-label pl-8 md:pl-0" htmlFor={rowName + "-" + answer.value} >
        <div className="md:text-center text-xs mb-1 md:mb-8">{answer.text}</div>
      </label>
    </div>
  );
  return multiRadios;
}

const Radio = ({qData, theme, nextStep}) => {

  const [shapeProps, setShapeProps] = useState([]);
  const [removeShapes, setRemoveShapes] = useState(false)

  const { register, handleSubmit, formState: { isValid } } = useForm({
    mode: 'onChange',
    defaultValues: {}
  });

  let radioButtons;

  if (qData.categories.length>0) {
    // grid of categories
    radioButtons = qData.categories.map((category, index) =>

      <div className="md:flex items-end mb-12 md:mb-6 nitro-cat-row" key={index}>
        <div className="md:shrink-0 grow md:w-1/4">
          <p className="mb-6 md:mb-0">{category.text}</p>
        </div>
        <div className="flex flex-col md:flex-row mt-2 md:mt-0 md:w-3/4">
          <MultiRadioRow register={register} answers={qData.options} rowName={`radio-${qData.id}-${index}`} sides={index} setShapeProps={setShapeProps} />
        </div>
      </div>

    );

  } else {
    // simple list
    radioButtons = qData.options.map((answer, index) => {

      return <div className="flex items-center mt-1 nitro-radio" key={index}>
        <input
          type="radio"
          {...register("radio-" + qData.id, {
            required: true,
            onChange: (e) => {
              setShapeProps([
                e.target.getAttribute("data-sides"),
                e.target.getAttribute("data-color"),
              ])
            }
          })}
          data-sides={index}
          data-color={index}
          id={"radio-" + answer.value}
          value={answer.value}
          className="opacity-0 absolute"
        />
        <label className="radio-label single-item" htmlFor={"radio-" + answer.value} >
          <div className="text-base md:text-3xl font-black">{answer.text}</div>
        </label>
      </div>

    }

    );
  }

  const onSubmit = (data) => {
    setRemoveShapes(true)
    nextStep(data)
  }

  const overallWidthClass = (qData.categories.length > 0) ? 'max-w-xl' : 'max-w-lg';

  return (
    <>
      <div className="grow py-12">
        <div className={`container ${overallWidthClass}`}>
          <form>
            {radioButtons}
            <input
              type="hidden"
              value={qData.id}
              {...register('questionId')}
            />
          </form>
        </div>
      </div>
      <NitroButton formIsValid={isValid} label="Next" onClick={handleSubmit(onSubmit)} />
      <ShapesDropping sides={shapeProps[0]} color={shapeProps[1]} theme={theme} removeShapes={removeShapes} />
    </>
  );
}

export default Radio;
